import { ProviderExtension } from "../registry";

export const slackExtension: ProviderExtension = {
  labels: {
    webClientIdLabel: "Client ID",
    webClientIdPlaceholder: "1234567890.1234567890",
  },
};
